import { useMutation, useQueryClient } from "@tanstack/react-query";

import { privateApi } from "@/api/axios";
import { profileQueryOptions } from "@/domains/profile/factories/profile-query-options";

export const useSaveProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveProfile,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: profileQueryOptions.current.queryKey,
      });
    },
  });
};

const saveProfile = async (profile: { sms_enabled: boolean; emails_enabled: boolean }) => {
  await privateApi.patch("/notifications", profile);
};
